import React from 'react'
import { useSelector } from 'react-redux'
import {
    Color,
    Cartesian3
} from 'cesium'
import {
    PointPrimitive,
    PointPrimitiveCollection
} from 'resium'

import { selectVertex } from '@/selector'
import { generateVertexes } from '@/util'
const PointLayer = () => {
    const vertex = useSelector(selectVertex)
    let points
    if (vertex.length < 2) {
        points = vertex.map((v, i) => {
            return (
                <PointPrimitive
                    key={`point-${v[0]}-${v[1]}`}
                    position={Cartesian3.fromDegrees(v[0], v[1])}
                    pixelSize={4}
                    color={Color.CHARTREUSE}
                />
            )
        })
    } else {
        const p = generateVertexes(vertex[0], vertex[1])
        points = p.map((v, i) => {
            return (
                <PointPrimitive
                    key={`point-${v[0]}-${v[1]}`}
                    position={Cartesian3.fromDegrees(v[0], v[1])}
                    pixelSize={4}
                    color={Color.CHARTREUSE}
                />
            )
        })
    }

    return (
        <PointPrimitiveCollection >
            {points}
        </PointPrimitiveCollection>
    )
}

export default PointLayer